import React from "react"
import { Grid, FormControl, Select, MenuItem } from "@material-ui/core"
import { ContactsFiltersConditions } from "@/protocols/ClientCatalogFilterProtocol"
import { PossibleContactHealthStatusSources } from "@/protocols/clientCatalog"

type ContactHealthFilterConditionProps = {
	condition: ContactsFiltersConditions<"contact_health">
	onChange: (condition: ContactsFiltersConditions<"contact_health">) => void
}

const ACCEPTED_CONTACT_HEALTH_STATUS: PossibleContactHealthStatusSources[] = [
	"no-exists",
	"exist",
	"unverified"
]

const statusLabels: Record<PossibleContactHealthStatusSources, string> = {
	"no-exists": "Não existem no WhatsApp",
	unverified: "Não foram validados",
	exist: "Existem no WhatsApp"
}

const ContactHealthFilterCondition: React.FC<ContactHealthFilterConditionProps> = (props) => {
	const { condition, onChange } = props

	const handleContactHealthChange = (status: PossibleContactHealthStatusSources) => {
		onChange({
			type: "contact_health",
			operator: "equal",
			filterData: { status }
		})
	}

	return (
		<Grid container direction="row" spacing={2}>
			<Grid item xs={12}>
				<FormControl fullWidth variant="outlined" size="small">
					<Select
						value={condition.filterData.status}
						onChange={({ target }) =>
							handleContactHealthChange(target.value as PossibleContactHealthStatusSources)
						}
					>
						{ACCEPTED_CONTACT_HEALTH_STATUS.map(status => (
							<MenuItem key={status} value={status}>
								{statusLabels[status]}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	)
}

export default ContactHealthFilterCondition
